import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Dashboard from "@/pages/Dashboard";
import PublicHome from "@/pages/PublicHome";
import AboutPage from "@/pages/AboutPage";
import PremiumPage from "@/pages/PremiumPage";
import BrandsPage from "@/pages/BrandsPage";
import CategoryPage from "@/pages/CategoryPage";
import Settings from "@/pages/Settings";
import Listings from "@/pages/Listings";
import Lander from "@/pages/Lander";
import Login from "@/pages/Login";
import Portfolio from "@/pages/Portfolio";
import AffiliateLinks from "@/pages/AffiliateLinks";
import AffiliateLander from "@/pages/AffiliateLander";
import Analytics from "@/pages/Analytics";
import Drops from "@/pages/Drops";
import MailPage from "@/pages/Mail";
import Inbox from "@/pages/Inbox";
import HotLeads from "@/pages/HotLeads";
import ProjectsList from "@/pages/ProjectsList";
import ProjectDetail from "@/pages/ProjectDetail";
import SoldDetail from "@/pages/SoldDetail";
import AdminProjects from "@/pages/AdminProjects";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/lib/auth";
import { BrandingProvider } from "@/lib/branding";

function App() {
  return (
    <div className="App font-sans">
      <BrowserRouter>
        <BrandingProvider>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/l/:slug" element={<Lander />} />
              <Route path="/a/:slug" element={<AffiliateLander />} />
              <Route path="/" element={<PublicHome />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/premium" element={<PremiumPage />} />
              <Route path="/brands" element={<BrandsPage />} />
              <Route path="/category/:slug" element={<CategoryPage />} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
              <Route path="/listings" element={<ProtectedRoute><Listings /></ProtectedRoute>} />
              <Route path="/portfolio" element={<ProtectedRoute><Portfolio /></ProtectedRoute>} />
              <Route path="/affiliate" element={<ProtectedRoute><AffiliateLinks /></ProtectedRoute>} />
              <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
              <Route path="/drops" element={<ProtectedRoute><Drops /></ProtectedRoute>} />
              <Route path="/mail" element={<ProtectedRoute><MailPage /></ProtectedRoute>} />
              <Route path="/inbox" element={<ProtectedRoute><Inbox /></ProtectedRoute>} />
              <Route path="/hot-leads" element={<ProtectedRoute><HotLeads /></ProtectedRoute>} />
              <Route path="/projects" element={<ProjectsList />} />
              <Route path="/projects/:slug" element={<ProjectDetail />} />
              <Route path="/sold/:slug" element={<SoldDetail />} />
              <Route path="/admin/projects" element={<ProtectedRoute><AdminProjects /></ProtectedRoute>} />
            </Routes>
          </AuthProvider>
        </BrandingProvider>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            borderRadius: "2px",
            border: "1px solid #eaecf0",
            fontFamily: "'IBM Plex Sans', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
